/**
 * Created by mmichieli on 07/02/2017.
 */
import { ReferentielModel } from './referentiel.model';

export class AudioContentModel {
  public id: number = null;
  public isDefault = false;
  public materialNumber: number;
  public languageId: number;
  public audioContentId: number;
  public audioFormatId: number;
  public licenceId: number;
  public typeMixId: number;
  public support: number;
  public supportLabel: string = null;
  public availabilityDate: string;

  public languageLabel: string = null;
  public audioContentLabel: string = null;
  public audioFormatLabel: string = null;
  public licenceLabel: string = null;
  public typeMixLabel: string = null;
  public statusLabel: string = null;

  public status: ReferentielModel = new ReferentielModel();
  public uuid: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
